import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

function Resources() {
  const linkClass = 'new-btn-secondary | text-base font-medium | py-2 px-11'

  return (
    <section className="bg-gradient-to-b from-[#050033] to-[#3F0066] text-white">
      <div className="container font-heading | py-10 md:py-18">
        <h2 className="text-3xl lg:text-4xl font-semibold md:text-center | md:max-w-col-8 md:mx-auto mb-10 md:mb-8">
          Resources for growing your product
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 | text-center">
          <div className="flex flex-col rounded-2xl">
            <div className="flex flex-col items-center flex-grow gap-5 md:gap-0 bg-gradient-to-b from-[#7C5C01] to-[#6F1DE2] | rounded-md md:rounded-lg | p-4 md:px-5">
              <Image
                src={'/assets/gml-2025/latest-blog-resource.png'}
                height={185}
                width={356}
                alt=""
                className="md:mb-4 rounded-sm md:rounded-md"
              />
              <h3 className="flex items-center font-semibold text-xl md:text-2xl | max-w-col-3 md:mb-3">
                Latest Blog
              </h3>
              <div className="font-body | text-sm md:text-base | px-4 md:px-5 mb-6 md:mb-8">
                Top 5 Questions to Ask When Selecting Content Marketing Agencies
              </div>
              <Link href="/blog/" target="_blank" className={linkClass}>
                Read More
              </Link>
            </div>
          </div>
          <div className="flex flex-col rounded-2xl">
            <div className="flex flex-col items-center flex-grow gap-5 md:gap-0 bg-gradient-to-b from-[#6252FF] to-[#008499] | rounded-md md:rounded-lg | p-4 md:px-5">
              <Image
                src={'/assets/gml-2025/latest-newsletter.png'}
                height={185}
                width={356}
                alt=""
                className="md:mb-4 rounded-sm md:rounded-md"
              />
              <h3 className="flex items-center font-semibold text-xl md:text-2xl | max-w-col-3 md:mb-3">
                Latest Newsletter
              </h3>
              <div className="font-body | text-sm md:text-base | px-4 md:px-5 mb-6 md:mb-8">
                The latest from Pepper Content, right in your inbox
              </div>
              <Link
                href="https://peppercontentinc.substack.com/"
                target="_blank"
                className={linkClass}
              >
                Subscribe Now
              </Link>
            </div>
          </div>
          <div className="flex flex-col rounded-2xl">
            <div className="flex flex-col items-center flex-grow gap-5 md:gap-0 bg-gradient-to-b  from-[#AD71FF] to-[#501A9B] | rounded-md md:rounded-lg | p-4 md:px-5">
              <Image
                src={'/assets/gml-2025/e-book.png'}
                height={185}
                width={356}
                alt=""
                className="md:mb-4 rounded-sm md:rounded-md"
              />
              <h3 className="flex items-center font-semibold text-xl md:text-2xl | max-w-col-3 md:mb-3">
                Ebooks
              </h3>
              <div className="font-body | text-sm md:text-base | px-4 md:px-5 mb-6 md:mb-8">
                Explore in-depth guides on content marketing, SEO, design, and
                more.
              </div>
              <Link
                href="/resources/?type=ebook"
                target="_blank"
                className={linkClass}
              >
                Download Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Resources
